'use client'
import Link from "next/link";
import { Supplement } from "../utils/supplements";
import HeaderNavItem from "./HeaderNavItem";
import HeaderSubtitle from "./HeaderSubtitle";
import { usePathname } from "next/navigation";
import Tooltip from "@/components/Tooltip";

export const headerTooltipContent = (
  <div className="rounded-lg px-4 py-3 font-sans [&_p:first-of-type]:mt-0 [&_p:last-of-type]:mb-0 [&_p]:text-base [&_ol]:text-base [&_ol]:m-0 [&_li]:text-base [&_li]:m-0 text-justify text-sm">
    <span className="text-lg font-bold font-mono block float-left border border-white px-1 rounded-md mr-4 mb-0 mt-[6px]">
      #1
    </span>
    <p>We disagree somewhat amongst ourselves about AI timelines; our median AGI arrival date is somewhat longer than what this scenario depicts. This scenario depicts something like our mode. See our <Link href="/research/timelines-forecast">timelines forecast</Link> for more details.</p>
  </div>
)

export const HeaderNavItems = ({ bottom = false, supplements, homepage }: { bottom?: boolean, supplements: Supplement[], homepage: boolean }) => {
  let reorderedSupplements = [...supplements];
  
  if (reorderedSupplements.length > 4) {
    const [item0, item1, item2, item3, item4] = reorderedSupplements;
    reorderedSupplements = [item1, item4, item3, item0, item2]
  }

  return (
    <nav className={`z-1 flex flex-wrap sm:gap-12 text-xl font-system-serif pl-2 sm:py-2 ${homepage ? 'mb-8 sm:mb-0' : 'mb-0'} items-center justify-between sm:justify-center ${homepage ? 'w-auto' : 'w-full'}`}>
      {!homepage && <> 
        <Link href="/" className="no-underline sm:mr-auto">
          <h1 className="mb-0 font-bold text-3xl whitespace-nowrap">AI 2027</h1>
        </Link>
      </>}
      <HeaderNavItem key="summary" href="/summary">
        Summary
      </HeaderNavItem>
      <div className="relative group">
        <HeaderNavItem key="research" href="/research">
          Research
        </HeaderNavItem>
        <div className={`absolute ${bottom ? 'bottom-[100%]' : 'top-[100%]'} w-[180px] hidden md:group-hover:block text-foreground right-0 font-sans text-sm [font-variant:normal] shadow-lg pb-2 pt-2 rounded bg-background border border-black z-50`}>
          {reorderedSupplements.map(({ slug, title }, i, arr) => (
            <span key={slug}>
              <Link
                key={slug}
                href={`/research/${slug}`}
                className="block py-2 whitespace-no-wrap no-underline text-med p-4 hover:bg-[var(--accent)] hover:text-background"
              >
                {title}
              </Link>
              {i < arr.length - 1 && <hr key={`${slug}-${i}`} className="bg-dull-foreground w-[90%] mx-auto h-0 my-0" />}
            </span>
          ))}
        </div>
      </div>
      <HeaderNavItem key="about" href="/about" box>
        About
      </HeaderNavItem>

    </nav>
  )
}
export default function Header({ supplements }: { supplements: Supplement[] }) {
  const pathname = usePathname();
  const isHomepage = (pathname === '/') || (pathname === '/summary');
  return (
    <nav className="flex flex-col [grid-area:header] z-1">
      <div className={`flex ${isHomepage ? 'flex-col-reverse sm:flex-row' : 'flex-row items-center'} justify-between mr-[1.5px] mt-0 sm:mt-8`}>
        {isHomepage && 
          <Link href="/" className="no-underline">
            <h1 className="mb-4 mt-2 whitespace-nowrap flex items-start">
              AI 2027
              <Tooltip content={headerTooltipContent} placement="right-start" interactive maxWidth={450}>
                <span className="text-lg font-bold ml-[5px] mt-[0px] text-accent">1</span>
              </Tooltip>
            </h1>
          </Link>
        }
        <HeaderNavItems supplements={supplements} homepage={isHomepage} />
      </div>
      {isHomepage && <HeaderSubtitle />}
      {/* <div className="w-full h-[640px]">
        <img src="/ai-timeline-diagram4.svg" className="absolute left-0 w-[100vw] mt-[-120px]" />
      </div> */}

    </nav>
  );
}